/**
 * Hamburger hand-off, every breakpoint.
 *
 * The store drawer IS the menu now. On a phone it always was; on desktop it
 * became the menu when the header moved to the `center-drawer` layout, which
 * drops the nav row and puts a labelled hamburger on the left of a centred
 * logo. Either way the header's own button (`.menu-drawer-button`) still wants
 * to open the theme's MenuDrawer, and that button lives in
 * sections/header.liquid — a 57KB file this component has no other reason to
 * touch. So the click is intercepted here instead.
 *
 * ⚠ IT HAS TO BE THE CAPTURE PHASE. The theme binds its own handler to the
 * button, and a bubble-phase listener on document runs after that, by which
 * point the old drawer is already opening. Capturing at document and calling
 * stopPropagation stops the event before it ever reaches the button.
 *
 * ⚠ THERE IS NO WIDTH GUARD, deliberately. There used to be one at 768px, from
 * when the desktop header still carried its own nav and the hamburger was
 * mobile-only. Under `center-drawer` the hamburger is the ONLY way into the
 * menu at any size, so a guard here would leave desktop opening the theme's
 * empty accordion. If the header layout is ever moved back to `left` or
 * `center`, this still costs nothing: the button is not rendered on desktop in
 * those layouts, so no click can reach this listener.
 *
 * The dock's Menu button is wired declaratively in sections/mobile-dock.liquid
 * and is skipped here — it carries data-sd-open and the main script handles it.
 * The dock is also hidden until the page is scrolled, which is exactly why the
 * header hamburger still has to work.
 */
(function () {
  'use strict';
  if (window.__storeDrawerMobile) return;
  window.__storeDrawerMobile = true;

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;

    var btn = t.closest('.menu-drawer-button, [aria-controls="MenuDrawer"]');
    if (!btn) return;
    if (btn.hasAttribute('data-sd-open')) return;      // already ours

    /* The drawer is fetched on demand now (see store-drawer.js), so its
       absence from the document is the normal state, not a reason to bail.
       Only a fetch that has actually failed hands the click back to the
       theme's own MenuDrawer. */
    if (window.__storeDrawerFailed) return;

    e.preventDefault();
    e.stopPropagation();

    /* Hand to the main script by synthesising the trigger it understands,
       rather than reaching into its closure. */
    var proxy = document.createElement('button');
    proxy.setAttribute('data-sd-open', 'shop');
    proxy.setAttribute('data-sd-panel-id', 'sd-s0');
    proxy.style.cssText = 'position:absolute;width:1px;height:1px;opacity:0;pointer-events:none';
    document.body.appendChild(proxy);
    proxy.click();
    window.setTimeout(function () { proxy.remove(); }, 0);
  }, true);
})();
